import React from 'react'
import { GoogleMap, Marker, InfoWindow } from '@react-google-maps/api'
import { Google } from './styles'
import { OverContainer, OverContainerSection } from '../styles'

export const Location = () => {
    const address = 'Cra. 9 B #10-112, Puerto Colombia, Atlántico'
    const [selectedMarker, setSelectedMarker] = React.useState(null)

    const coordinates = { lat: 10.989493237399024, lng: -74.95405762331109 }
    const handleMarkerClick = (marker: any) => {
        setSelectedMarker(marker)
    }
    return (
        <OverContainerSection>
            <OverContainer
                marginTop={['xlarge', 'xlarge', 'xxmedium', 'xxlarge']}
            >
                <Google>
                    <GoogleMap
                        center={coordinates}
                        zoom={15}
                        mapTypeId="satellite"
                        mapContainerStyle={{ width: '100%', height: '100%' }}
                    >
                        <Marker
                            position={coordinates}
                            onClick={() => handleMarkerClick(true)}
                        />

                        {selectedMarker && (
                            <InfoWindow
                                position={coordinates}
                                onCloseClick={() => setSelectedMarker(null)}
                            >
                                <div>{address}</div>
                            </InfoWindow>
                        )}
                    </GoogleMap>
                </Google>
            </OverContainer>
        </OverContainerSection>
    )
}
